import { Input } from "@/components/ui/Field";
import { Button } from "@/components/ui/Button";

interface PucActionsBarProps {
  title: string;
  search: string;
  onSearchChange: (value: string) => void;
  onDownloadTemplate: () => void;
  onAdd: () => void;
}

export const PucActionsBar = ({
  title,
  search,
  onSearchChange,
  onDownloadTemplate,
  onAdd,
}: PucActionsBarProps) => (
  <div className="flex flex-wrap items-center justify-between gap-2">
    <h3 className="text-sm font-semibold text-ink-primary">{title}</h3>
    <div className="flex gap-2">
      <Input
        placeholder="Buscar por código o nombre..."
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
        className="w-64"
      />
      <Button variant="outline" size="sm" onClick={onDownloadTemplate}>
        Plantilla
      </Button>
      <Button size="sm" onClick={onAdd}>
        Agregar cuenta
      </Button>
    </div>
  </div>
);